import { socketService } from '../socketService';
import { ClientConversation } from '../../store/chat/types';
import { SocketEventType, SocketMessage } from '../types';
import { AIModel } from '../../types/AIModels';
import { RAGMode } from '../../types/RAGModes';
import { QueryType } from '../../types/QueryTypes';

export interface ChatRequestData {
  query: string;
  conversationId?: string;
  model?: AIModel;
  ragMode?: RAGMode;
  docName?: string;
  topK?: number;
  relevancePercent?: number;
  traceTag?: string;
  forceQueryType?: QueryType;
  filteredCompanyIds?: string[];
}

type ChatResponseData =
  | {
      conversation: ClientConversation;
      error?: never;
      dailyMessageCount?: never;
      limitHitTime?: never;
      resetTime?: never;
    }
  | {
      conversation?: never;
      error: string;
      dailyMessageCount?: number;
      limitHitTime?: string;
      resetTime?: string;
    };

export const sendUserChatMessage = async (data: ChatRequestData): Promise<ChatResponseData> => {
  const message: SocketMessage<ChatRequestData> = {
    type: SocketEventType.UserChatMessage,
    payload: data,
    timestamp: new Date().toISOString(),
  };

  const response = await socketService.emitWithAck<ChatRequestData, ChatResponseData>(
    SocketEventType.UserChatMessage,
    message,
  );

  return response;
};
